import { Grid, Box } from '@mui/material';

import useBanners from 'store/banners';

import useScreen from 'hooks/useScreen';
import { BANNERS, MOBILE_BANNERS } from 'config';

import BannersSlider from './BannersSlider';

const BannersSection = () => {
  const { isMobile } = useScreen();
  const [banners] = useBanners();

  const BANNER_KEY = isMobile ? MOBILE_BANNERS.home : BANNERS.home;
  const bannersData = banners?.data?.find((bannerGroup) => bannerGroup.page === BANNER_KEY);

  if (!bannersData) {
    return null;
  }

  return (
    <Box component="section" my={2} mx={isMobile ? '-24px' : 0}>
      <Grid container spacing={3}>
        {bannersData.banners
          .filter((banner) => banner.width)
          .sort((bnr1, bnr2) => bnr1.order - bnr2.order)
          .map((banner, index) => (
            <Grid
              item
              xs={banner.width}
              key={index}
              sx={{
                '& .slick-slider, & .slick-list, & .slick-track, & .slick-slide, & .slick-slide > div': {
                  height: '100% !important',
                },
              }}
            >
              <BannersSlider bannerItems={banner.bannerItems} width={banner.width} />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default BannersSection;
